import React from "react";
import { useNavigate } from "react-router-dom";
import { pageRoutes } from "../routes/pageRoutes";
import { useDispatch, useSelector } from "react-redux";
import { toggleChange } from "../redux/reducers/authReducer";
import { pipGetAccessToken, pipGetProfile } from "../utils/pip";

const Header = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const isAuth = pipGetAccessToken();
  const profileDetail = pipGetProfile();
  const { isToggle } = useSelector((state) => state.authReducer);

  return (
    <>
      <header>
        <div class="ct_logo">
          <img src="images/logo.png" alt="" />
        </div>
        <div class="ct_nav_menu">
          <ul className={isToggle ? "ct_show_menu" : ""}>
            <i
              onClick={() => {
                dispatch(toggleChange(false));
              }}
              class="fa-solid fa-xmark ct_close_menu ct_cursor_pointer"
            ></i>

            <li class="ct_dropdown_main">
              <a
                href="javascript:void(0)"
                onClick={() => navigate(pageRoutes?.home)}
              >
                Home
              </a>
            </li>

            <li class="ct_dropdown_main">
              <a
                href="javascript:void(0)"
                onClick={() => navigate(pageRoutes?.lexicon)}
              >
                Knowledgebase
              </a>
            </li>

            <li onClick={() => navigate(pageRoutes.more?.eventCoverageResults)}>
              <a href="javascript:void(0)">Events </a>
            </li>
            <li className="ct_dropdown_main">
              <a href="javascript:void(0)">
                Team & Bot Directory <i class="fa-solid fa-angle-down ms-2"></i>
              </a>
              <ul class="ct_custom_dropdown">
                <li onClick={() => navigate(pageRoutes.more?.teamDirectory)}>
                  <a href="javascript:void(0)">Team Directory</a>
                </li>
                <li onClick={() => navigate(pageRoutes.botDirectory)}>
                  <a href="javascript:void(0)">Bot Directory</a>
                </li>
              </ul>
            </li>

            <li onClick={() => navigate(pageRoutes.more?.partners)}>
              <a href="javascript:void(0)">Partners</a>
            </li>
            <li onClick={() => navigate(pageRoutes.mediaContent)}>
              <a href="javascript:void(0)">Media</a>
            </li>
           
              <li
                className="ct_dropdown_main"
                //  onClick={() => navigate(pageRoutes?.sparcRule)}
              >
                <a
                  href="javascript:void(0)"
                  onClick={() => navigate(pageRoutes.Curriculum)}
                >
                  Curriculum
                </a>
              </li>
            {/* show only  paying customers */}
            <li className="ct_dropdown_main d-none">
              <a href="javascript:void(0)">
                Paywall <i class="fa-solid fa-angle-down ms-2"></i>
              </a>
              <ul className="ct_custom_dropdown">
                <li className="ct_dropdown_main2">
                  <a href="javascript:void(0)">
                    Classroom Portal <i class="fa-solid fa-angle-down ms-2"></i>
                  </a>
                  <ul className="ct_custom_dropdown2">
                    <li>
                      <a href="javascript:void(0)">My Classes</a>
                    </li>
                    <li>
                      <a href="javascript:void(0)">Curricular Units</a>
                    </li>
                    <li>
                      <a href="javascript:void(0)">Lesson Directory</a>
                    </li>
                  </ul>
                </li>
              </ul>
            </li>
          </ul>
        </div>
        <div class="d-flex align-items-center gap-4">
          <ul class="ct_right_menu ms-5">
            {pipGetAccessToken() ? (
              <>
                <li
                  className="dropdown"
                  // onClick={() => navigate(pageRoutes?.myAccount)}
                >
                  <a
                    href="javascript:void(0)"
                    id="dropdownMenuButton1"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <img
                      src={
                        profileDetail?.google_profile_image ??
                        profileDetail?.profile_image ??
                        "./images/user_profile.png"
                      }
                      className="ec_profile_user_icon12"
                    />
                  </a>
                  <ul
                    class="dropdown-menu rc_dropdown_23"
                    aria-labelledby="dropdownMenuButton1"
                  >
                    <li>
                      <a
                        class="dropdown-item"
                        href="javascript:void(0)"
                        onClick={() => navigate(pageRoutes?.profile)}
                      >
                        <i class="fa-solid fa-user me-2"></i> Profile
                      </a>
                    </li>
                    <li>
                      <a
                        class="dropdown-item"
                        data-bs-toggle="modal"
                        data-bs-target="#ct_logout_modal"
                        href="#"
                      >
                        <i class="fa-solid fa-power-off me-2"></i>Log Out
                      </a>
                    </li>
                  </ul>
                </li>
                {/* <li onClick={() => navigate(pageRoutes?.cart)}>
                  <a href="javascript:void(0)">
                    <img src="images/cart.svg" />
                  </a>
                </li> */}
              </>
            ) : (
              <>
                <li
                
                className={pageRoutes?.login ? "active" : ""}
                >
                  <a
                  // onClick={() => {
                  //   navigate(pageRoutes?.login);
                  // }}
                  target="_blank"
                  href={`${window.location.origin}${pageRoutes?.login}`}
                    className="text-white ct_fs_16 rc_signup_btn_bg_123"
                  >
                    Classroom Portal Sign in
                  </a>
                </li>
              </>
            )}
            <li>
              <div
                class="ct_menu_bar"
                onClick={() => {
                  dispatch(toggleChange(true));
                }}
              >
                <i class="fa-solid fa-bars"></i>
              </div>
            </li>
          </ul>
        </div>
      </header>

      {/* logout confirmation */}
      <div
        className="modal fade ct_assets_modal"
        id="ct_logout_modal"
        tabIndex="-1"
        aria-labelledby="ct_logout_modalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header border-0 pt-0">
              <button
                type="button"
                className="btn-close ct_cloose_btn"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="fa-solid fa-xmark"></i>
              </button>
            </div>
            <div className="modal-body border-0 ">
              <svg
                width="21"
                height="20"
                viewBox="0 0 21 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M10.0117 0C4.51172 0 0.0117188 4.5 0.0117188 10C0.0117188 15.5 4.51172 20 10.0117 20C15.5117 20 20.0117 15.5 20.0117 10C20.0117 4.5 15.5117 0 10.0117 0ZM10.0117 15.9C6.81172 15.9 4.11172 13.3 4.11172 10C4.11172 8.3 4.91172 6.6 6.21172 5.5C6.61172 5.2 7.31172 5.2 7.61172 5.6C8.01172 6.1 7.91172 6.7 7.51172 7.1C6.61172 7.8 6.11172 8.9 6.11172 10.1C6.11172 12.2 7.81172 14 10.0117 14C12.2117 14 13.9117 12.3 13.9117 10.1C13.9117 9 13.4117 7.9 12.5117 7.1C12.1117 6.8 12.0117 6.1 12.4117 5.7C12.8117 5.3 13.4117 5.2 13.8117 5.6C15.1117 6.7 15.9117 8.4 15.9117 10.1C15.9117 13.3 13.2117 15.9 10.0117 15.9ZM10.0117 3.5C10.5117 3.5 11.0117 3.9 11.0117 4.5V8.2C11.0117 8.7 10.5117 9.2 10.0117 9.2C9.51172 9.2 9.01172 8.7 9.01172 8.2V4.5C9.01172 3.9 9.51172 3.5 10.0117 3.5Z"
                  fill="#DC0202"
                ></path>
              </svg>
              <h4 className="text-center mb-4 ct_fw_600">Log Out Account</h4>
              <p className="text-center ct_grey_text">
                Are you sure, you want to logout? once you logout <br /> you
                need to login again.
              </p>
              <div className="modal-footer border-0 justify-content-center">
                <button
                  type="button"
                  className="ct_single_cart_btn ct_btn_animate ghost ct_black_animation_btn"
                  data-bs-dismiss="modal"
                >
                  Cancel
                </button>
                <a
                  onClick={() => {
                    // clearAuth();
                    localStorage.removeItem("rc01_transictionId");
                    localStorage.removeItem("users_data_rc01");
                    localStorage.removeItem("rc01-token");
                    localStorage.removeItem("Team-Member-Detail");
                    navigate(pageRoutes?.login);
                  }}
                  href="javascript:void(0)"
                  type="button"
                  data-bs-dismiss="modal"
                  className="bg-danger ct_single_cart_btn ct_btn_animate ghost ct_black_animation_btn"
                  style={{ borderColor: "rgb(220, 53, 69)" }}
                >
                  Logout
                </a>
              </div>
              <div></div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Header;
